// @ts-ignore
import MuiGetScrollbarSize from '@material-ui/core/utils/getScrollbarSize';
/**
 * get document scrollbar size
 *
 * this method inside mui utils
 * @see {@link https://github.com/mui-org/material-ui/blob/master/packages/material-ui/src/utils/getScrollbarSize.js mui-source}
 */
export var getScrollbarSize = MuiGetScrollbarSize;
